export const EVENTS_NAME = {
    add_a_spot_view: 'add_a_spot_view',
    booking_confirmation_view: 'booking_confirmation_view',
    chat_view: 'chat_view',
    checkout_payment_view: 'checkout_payment_view',
    checkout_profile_view: 'checkout_profile_view',
    checkout_rules_view: 'checkout_rules_view',
    checkout_view: 'checkout_view',
    edit_spot_view: 'edit_spot_view',
    guest_calendar_view: 'guest_calendar_view',
    guest_manage_membership_view: 'guest_manage_membership_view',
    guest_memberships_view: 'guest_memberships_view',
    guest_message_list_view: 'guest_message_list_view',
    guest_message_thread_view: 'guest_message_thread_view',
    home_view: 'home_view',
    host_account_view: 'host_account_view',
    host_calendar_view: 'host_calendar_view',
    host_landing_page_view: 'host_landing_page_view',
    host_manage_memberships_view: 'host_manage_memberships_view',
    host_memberships_view: 'host_memberships_view',
    host_message_list_view: 'host_message_list_view',
    host_message_thread_view: 'host_message_thread_view',
    host_review_list_view: 'host_review_list_view',
    listings_ads_view: 'listings_ads_view',
    membership_signup_view: 'membership_signup_view',
    publish_spot_click: 'publish_spot_click',
    reservation_detail_view: 'reservation_detail_view',
    reservation_list_view: 'reservation_list_view',
    search_location_success: 'search_location_success',
    search_view: 'search_view',
    signup_page_view: 'signup_page_view',
    sniffpass_learn_more_click: 'sniffpass_learn_more_click',
    spot_detail_view: 'spot_detail_view',
    visit_cancel_view: 'visit_cancel_view',
    visit_detail_view: 'visit_detail_view',
    visit_edit_view: 'visit_edit_view',
    visit_list_view: 'visit_list_view',

    // membership landing page
    membership_landing_general_cta: 'membership_landing_general_cta',
    membership_landing_card_cta: 'membership_landing_card_cta',
    membership_landing_billing_toggle: 'membership_landing_billing_toggle',
    membership_landing_scroll: 'membership_landing_scroll',
    membership_landing_faq_expand: 'membership_landing_faq_expand',
    membership_landing_testimonial_engage: 'membership_landing_testimonial_engage',

    // referral
    referral_invite_sent: 'referral_invite_sent',

    // experiments
    experiment_assigned: 'experiment_assigned',
    experiment_conversion: 'experiment_conversion',
};

export const EVENTS_ANALYTICS = {
    screen_home: 'screen_home',
    booking: 'booking',
    conversion: 'conversion',
    screen_checkout_calendar: 'screen_checkout_calendar',
    screen_checkout_page: 'screen_checkout_page',
    screen_checkout_profile: 'screen_checkout_profile',
    screen_checkout_payment: 'screen_checkout_payment',
    screen_booking_confirmed: 'screen_booking_confirmed',
    screen_search: 'screen_search',
    purchase: 'purchase',
    start_trial: 'start_trial',
    complete_registration: 'complete_registration',
    screen_spot_details: 'screen_spot_details',
    screen_visits: 'screen_visits',
    screen_visit_details: 'screen_visit_details',
    screen_guest_account: 'screen_guest_account',
    screen_host_account: 'screen_host_account',
    screen_guest_chat_thread: 'screen_guest_chat_thread',
    screen_guest_messages_list: 'screen_guest_messages_list',
    screen_host_chat_thread: 'screen_host_chat_thread',
    screen_host_messages_list: 'screen_host_messages_list',
    screen_host_reservations_list: 'screen_host_reservations_list',
    screen_host_details: 'screen_host_details',
    screen_host_reviews: 'screen_host_reviews',
    screen_host_calendar: 'screen_host_calendar',
    screen_amenities: 'screen_amenities',
    screen_extras: 'screen_extras',
    screen_policies: 'screen_policies',
    screen_spot_rules: 'screen_spot_rules',
    screen_reviews: 'screen_reviews',
    screen_present: 'screen_present',
    screen_user_profile: 'screen_user_profile',
    screen_reviews_photo: 'screen_reviews_photo',
    screen_membership: 'screen_membership',
    screen_visit_edit: 'screen_visit_edit',
    screen_visit_cancel: 'screen_visit_cancel',
    screen_host_landing: 'screen_host_landing',
    screen_add_spot: 'screen_add_spot',
    screen_edit_spot: 'screen_edit_spot',
    load_more_reviews_press: 'load_more_reviews_press',
    modal_filters: 'modal_filters',
    modal_membership_confirmation: 'modal_membership_confirmation',
    modal_membership_payment: 'modal_membership_payment',
    filters_saved: 'filters_saved',
    filters_removed: 'filters_removed',
    search_screen_scroll: 'search_screen_scroll',
    filter_fencedany: 'filter_fencedany',
    filter_fenced3: 'filter_fenced3',
    filter_fenced4: 'filter_fenced4',
    filter_fenced5: 'filter_fenced5',
    filter_fenced6: 'filter_fenced6',
    filter_size025: 'filter_size025',
    filter_size05: 'filter_size05',
    filter_size1: 'filter_size1',
    filter_size2: 'filter_size2',
    filter_size5: 'filter_size5',
    filter_size10: 'filter_size10',
    filter_distance05: 'filter_distance05',
    filter_distance1: 'filter_distance1',
    filter_distance5: 'filter_distance5',
    filter_distance10: 'filter_distance10',
    filter_distance20: 'filter_distance20',
    filter_distance50: 'filter_distance50',
    filter_nodogs: 'filter_nodogs',
    filter_nopeople: 'filter_nopeople',
    filter_nodomesticanimals: 'filter_nodomesticanimals',
    filter_availability: 'filter_availability',
    filter_dateonly: 'filter_dateonly',
    filter_timeonly: 'filter_timeonly',
    filter_datetime: 'filter_datetime',
    filter_date1: 'filter_date1', // this event should fire when a user selects 1 date and no time
    filter_date2: 'filter_date2', // this event should fire when a user selects more than 1 date and no time
    filter_time1: 'filter_time1', // this event should fire when a user selects no date and 1 time
    filter_time2: 'filter_time2', // this event should fire when a user selects no date and 2+ times
    filter_date1time1: 'filter_date1time1', // this event should fire when a user selects 1 date and 1 time
    filter_date1time2: 'filter_date1time2', // this event should fire when a user selects 1 date and 2+ times
    filter_date2time2: 'filter_date2time2', // this event should fire when a user selects 2+ dates and 2+ times
    filter_date2time1: 'filter_date2time1', // this event should fire when a user selects 2+ dates and 1 time
    filter_all_waterparks: 'filter_all_waterparks',
    filter_hiking: 'filter_hiking',
    filter_indoor: 'filter_indoor',
    filter_beach: 'filter_beach',
    filter_agility: 'filter_agility',
    filter_field: 'filter_field',
    filter_smalldog: 'filter_smalldog',
    filter_topspots: 'filter_topspots',
    filter_newspots: 'filter_newspots',
    filter_cleanspots: 'filter_cleanspots',
    filter_lake_pond: 'filter_lake_pond',
    filter_river_stream_creek: 'filter_river_stream_creek',
    filter_swimming_pool: 'filter_swimming_pool',
    filter_accessible: 'filter_accessible',
    filter_lit_at_night: 'filter_lit_at_night',
    filter_indoor_restroom: 'filter_indoor_restroom',
    filter_fertilizer_free: 'filter_fertilizer_free',
    filter_pesticide_free: 'filter_pesticide_free',
    filter_rain_shelter: 'filter_rain_shelter',
    filter_snow: 'filter_snow',
    filter_max_dogs: 'filter_max_dogs',
    filter_min_price: 'filter_min_price',
    filter_max_price: 'filter_max_price',
    search_location: 'search_location',
    spot_created: 'spot_created',
    host_account_created: 'host_account_created',
    new_guest: 'new_guest',
    new_subscription: 'new_subscription',
    screen_sign_in: 'screen_sign_in',
    screen_sign_up: 'screen_sign_up',
    search_sort: 'search_sort',
    warning_rating: 'warning_rating', // a safety warning due to a spot having a low rating
    warning_inactive: 'warning_inactive', // a safety warning due to a spot not being booked recently, i.e. being inactive
    warning_fencing: 'warning_fencing', // a safety warning due to fencing issues
    warning_clean: 'warning_clean', // a safety warning due to cleanliness issues
    warning_photos: 'warning_photos', // a safety warning due to too few photos
    host_link_copy: 'host_link_copy',
    map_view: 'map_view',
    list_view: 'list_view',
    share_search: 'share_search',
    filter_advance_notice: 'filter_advance_notice',
    filter_review_rating: 'filter_review_rating',
    filter_membership_discount: 'filter_membership_discount',
    filter_sniffpass_discount: 'filter_sniffpass_discount',
    filter_chairs: 'filter_chairs',
    filter_dog_bags: 'filter_dog_bags',
    filter_dog_drinking_water: 'filter_dog_drinking_water',
    filter_sign: 'filter_sign',
    filter_trash_can: 'filter_trash_can',
    filter_dock_for_dog_diving: 'filter_dock_for_dog_diving',
    filter_lure_course: 'filter_lure_course',
    filter_water_hose: 'filter_water_hose',
    filter_kiddie_pool: 'filter_kiddie_pool',
    filter_bug_spray: 'filter_bug_spray',
    filter_electric_outlet: 'filter_electric_outlet',
    filter_parking: 'filter_parking',
    filter_pooper_scooper: 'filter_pooper_scooper',
    filter_table: 'filter_table',
    filter_wifi: 'filter_wifi',
    filter_farm_animal: 'filter_farm_animal',
    filter_hill: 'filter_hill',
    filter_pasture: 'filter_pasture',
    filter_short_grass: 'filter_short_grass',
    filter_woods: 'filter_woods',
    filter_open_now: 'filter_open_now',
    filter_no_dogs_saw: 'filter_no_dogs_saw',
    filter_no_dogs_heard: 'filter_no_dogs_heard',
    filter_no_domestic_animals_saw: 'filter_no_domestic_animals_saw',
    filter_no_domestic_animals_heard: 'filter_no_domestic_animals_heard',
    filter_no_people_saw: 'filter_no_people_saw',
    filter_no_people_heard: 'filter_no_people_heard',
    lead: 'lead',
    spot_published: 'spot_published',
    paid_membership: 'paid_membership',
    cancelled_membership: 'cancelled_membership',
    resurrected_membership: 'resurrected_membership',
    paid_sign_up: 'paid_sign_up',
    membership_landing_scroll: 'membership_landing_scroll',
    membership_landing_faq_expand: 'membership_landing_faq_expand',
    membership_landing_billing_toggle: 'membership_landing_billing_toggle',
    membership_landing_general_cta: 'membership_landing_general_cta',
    membership_landing_card_cta: 'membership_landing_card_cta',
};
